// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__SGP0C","icon":"EnquiryForm_icon__V6O8z","heading":"EnquiryForm_heading__3RTsc","field":"EnquiryForm_field__3vl89","error":"EnquiryForm_error__id00z"};